import * as React from 'react';

export interface ICircleProgressProps {
    value: number;
}

const CircleProgress = (props: ICircleProgressProps) => {
    const { value } = props;
    const clampedValue = Math.min(12, Math.max(0, value));

    const angle = (clampedValue / 12) * 360;

    const uniqueId = React.useMemo(() => {
        return `cut-out-${Math.random().toString(36).substr(2, 9)}`;
    }, []);

    return (
        <svg width={26} height={26} viewBox='0 0 120 120'>
            <circle
                cx={60}
                cy={60}
                r={55}
                stroke="#002242"
                strokeWidth={10}
                fill="none"
            />

            <mask id={`cut-out-${uniqueId}`}>
                <rect width={120} height={120} fill='black' />
                <path
                    d={`M 60 60 L 60 5 A 55 55 0 ${angle > 180 ? 1 : 0} 1 ${60 +
                        55 * Math.sin((angle * Math.PI) / 180)} ${60 -
                        55 * Math.cos((angle * Math.PI) / 180)} Z`}
                    fill='white'
                />
            </mask>

            <circle
                cx={60}
                cy={60}
                r={40}
                fill='#002242'
                mask={`url(#cut-out-${uniqueId})`}
            />
        </svg>
    );
};

export default CircleProgress;
